import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/header";
import HomeSection from "./components/homeSection";
import CustomCursor from "./components/CustomCursor";
import "./App.css";

const App = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("portfolio-theme") || "light",
  );
  useEffect(() => {
    localStorage.setItem("portfolio-theme", theme);
    document.documentElement.dataset.theme = theme;
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", theme === "dark" ? "#091321" : "#f6f3ec");

    return () => {
      delete document.documentElement.dataset.theme;
    };
  }, [theme]);

  useEffect(() => {
    const cardSelector =
      ".about-copy, .fact, .timeline-card, .skill-group, .project-card, .recognition-card, .certificate-card, .journey-card, .hobby-card";
    const precisePointer = window.matchMedia(
      "(hover: hover) and (pointer: fine)",
    );
    if (!precisePointer.matches) return undefined;

    let frame = 0;
    let pendingPointer = null;

    const updateCardShadow = (event) => {
      pendingPointer = {
        target: event.target,
        x: event.clientX,
        y: event.clientY,
      };
      if (frame) return;

      frame = window.requestAnimationFrame(() => {
        const pointer = pendingPointer;
        const card = pointer?.target.closest?.(cardSelector);
        if (card) {
          const bounds = card.getBoundingClientRect();
          const horizontal = (pointer.x - bounds.left) / bounds.width - 0.5;
          const vertical = (pointer.y - bounds.top) / bounds.height - 0.5;
          const shadowX = horizontal * 30;
          const shadowY = vertical * 24;

          card.style.setProperty("--shadow-x", `${shadowX}px`);
          card.style.setProperty("--shadow-y", `${shadowY}px`);
          card.style.setProperty("--shadow-opposite-x", `${-shadowX}px`);
          card.style.setProperty("--shadow-opposite-y", `${-shadowY}px`);
        }
        frame = 0;
      });
    };

    document.addEventListener("pointermove", updateCardShadow, {
      passive: true,
    });
    return () => {
      document.removeEventListener("pointermove", updateCardShadow);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <Router>
      <div className={`app-shell ${theme}`}>
        <CustomCursor />
        <Header
          theme={theme}
          onThemeChange={() => setTheme(theme === "dark" ? "light" : "dark")}
        />
        <HomeSection />
        <Footer />
      </div>
    </Router>
  );
};
export default App;
